module.exports = __webpack_public_path__ + "static/service-shaves-5404ee14b05b0fa6d4b3738ae4456210.jpg";